import { Location } from "history";
import * as queryString from "query-string";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Container, Dimmer, Loader } from "semantic-ui-react";
import { login } from "../actions/users/users";
import Login from "../components/auth/Login";
import CustomFailure from "../components/common/CustomFailure";
import CustomSuccess from "../components/common/CustomSuccess";
import { delayBeforeRedirect } from "../config/constants";
import { AppDispatch, RootState } from "../reducers";
import { delay, exists } from "../utils/utils";

const mapStateToProps = (state: RootState) => ({
  showSuccessMessage: state.statusMessages.showSuccessMessage,
  showFailureMessage: state.statusMessages.showFailureMessage,
  submitSucceededMessageHeader: state.statusMessages.submitSucceededMessageHeader,
  submitSucceededMessageContent: state.statusMessages.submitSucceededMessageContent,
  submitFailedMessageHeader: state.statusMessages.submitFailedMessageHeader,
  submitFailedMessageContent: state.statusMessages.submitFailedMessageContent,
  isLoading: state.statusMessages.isLoading
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  login: (username: string, password: string, captchaToken: string, code: string | undefined) =>
    dispatch(login(username, password, captchaToken, code))
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;
type LoginViewProps = { location?: Location } & PropsFromRedux;
type LoginViewState = {
  showCreatedAccountSuccessMessage: boolean;
  openResetPasswordModal: boolean;
};

class LoginView extends React.Component<LoginViewProps, LoginViewState> {
  constructor(props: LoginViewProps) {
    super(props);

    let showCreatedAccountSuccessMessage = false;
    let openResetPasswordModal = false;
    if (this.props.location) {
      if (exists(queryString.parse(this.props.location.search).created_account_success)) {
        showCreatedAccountSuccessMessage =
          queryString.parse(this.props.location.search).created_account_success === "true";
      } else if (exists(queryString.parse(this.props.location.search).open_forgot_password)) {
        openResetPasswordModal =
          queryString.parse(this.props.location.search).open_forgot_password === "true";
      }
    }
    this.state = { showCreatedAccountSuccessMessage, openResetPasswordModal };
  }

  componentDidMount() {
    delay(delayBeforeRedirect).then(() => {
      this.setState({
        showCreatedAccountSuccessMessage: false
      });
    });
  }

  handleSubmit(values: { username: string; password: string; captchaToken: string; code: string }) {
    this.props.login(values.username, values.password, values.captchaToken, values.code);
  }

  render() {
    return (
      <Container>
        <Dimmer.Dimmable blurring dimmed={this.props.isLoading}>
          <Loader />
        </Dimmer.Dimmable>
        {this.props.showSuccessMessage && (
          <CustomSuccess
            header={this.props.submitSucceededMessageHeader}
            content={this.props.submitSucceededMessageContent}
          />
        )}
        {this.props.showFailureMessage && (
          <CustomFailure
            header={this.props.submitFailedMessageHeader}
            content={this.props.submitFailedMessageContent}
          />
        )}
        <Login
          onSubmit={(values: any) => {
            this.handleSubmit(values);
          }}
          showCreatedAccountSuccessMessage={this.state.showCreatedAccountSuccessMessage}
        />
      </Container>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginView);
